import { KIND_PRIMARY, SIZE_FIXED } from "factor-lib/Buttons/Button";

export const ButtonKind = KIND_PRIMARY;
export const ButtonSize = SIZE_FIXED;
